import React, {Fragment} from 'react';
import {Autocomplete, TextField, CircularProgress} from '@mui/material';
import {translations} from 'presentation/translations-new';
import {AutocompleteSelectProps} from './types';

const {loading: loadingLabel, noOptions} = translations['pt-br'].commons;

export function AutocompleteSelect<T>({
	dataTagId,
	componentKey,
	disabled,
	customPlaceholder,
	value,
	onValueChange,
	options,
	getOptionLabel,
	getOptionValue,
	loading = false,
	noOptionsText = noOptions,
	loadingText = loadingLabel,
	dataTest,
	shouldDisablePortal = false,
}: AutocompleteSelectProps<T>) {
	const selectedOption = options.find(opt => getOptionValue(opt) === value) ?? null;

	return (
		<Autocomplete
			disabled={disabled}
			options={options}
			value={selectedOption}
			isOptionEqualToValue={(opt, val) => getOptionValue(opt) === getOptionValue(val)}
			getOptionLabel={opt => getOptionLabel(opt) ?? ''}
			onChange={(_, newValue) => {
				onValueChange(newValue ? getOptionValue(newValue) : '');
			}}
			loading={loading}
			loadingText={loadingText}
			noOptionsText={noOptionsText}
			disablePortal={shouldDisablePortal}
			renderInput={params => (
				<TextField
					{...params}
					key={componentKey}
					placeholder={customPlaceholder}
					label={customPlaceholder}
					slotProps={{
						input: {
							...params.InputProps,
							endAdornment: (
								<Fragment>
									{loading ? (
										<CircularProgress color="inherit" size={20} />
									) : null}
									{params.InputProps.endAdornment}
								</Fragment>
							),
						},
						htmlInput: {
							...params.inputProps,
							'data-testid': dataTest,
							'data-tag-id': dataTagId,
						},
					}}
				/>
			)}
		/>
	);
}
